export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-qa.ria.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-qa.ria.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-qa.ria.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/ria-avwave-qa/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
